import {
    GET_DEVICE,
    GET_DEVICE_SUCCESS,
    GET_DEVICE_FAILURE,
    SSID,
    SSID_SUCCESS,
    SSID_FAILURE,
    PASSWORD,
    PASSWORD_SUCCESS,
    PASSWORD_FAILURE,
    REBOOT,
    REBOOT_SUCCESS,
    REBOOT_FAILURE,
    RESET,
    RESET_SUCCESS,
    RESET_FAILURE,
} from './actionTypes';
import * as types from './types';

// get Device
export const GetDevice = (payload: types.GetDeviceRequestPayload): types.GetDeviceRequest => ({
    type: GET_DEVICE,
    payload,
});

export const GetDeviceSuccess = (payload: types.GetDeviceSuccessPayload): types.GetDeviceSuccess => ({
    type: GET_DEVICE_SUCCESS,
    payload,
});

export const GetDeviceFailure = (payload: types.GetDeviceFailurePayload): types.GetDeviceFailure => ({
    type: GET_DEVICE_FAILURE,
    payload,
});

// ssid post api
export const Ssid = (payload: types.SsidRequestPayload): types.SsidRequest => ({
    type: SSID,
    payload,
});

export const SsidSuccess = (payload: types.SsidSuccessPayload): types.SsidSuccess => ({
    type: SSID_SUCCESS,
    payload,
});

export const SsidFailure = (payload: types.SsidFailurePayload): types.SsidFailure => ({
    type: SSID_FAILURE,
    payload,
});

// password post api
export const Password = (payload: types.PasswordRequestPayload): types.PasswordRequest => ({
    type: PASSWORD,
    payload,
});

export const PasswordSuccess = (payload: types.PasswordSuccessPayload): types.PasswordSuccess => ({
    type: PASSWORD_SUCCESS,
    payload,
});

export const PasswordFailure = (payload: types.PasswordFailurePayload): types.PasswordFailure => ({
    type: PASSWORD_FAILURE,
    payload,
});

// reboot post api
export const Reboot = (payload: types.RebootRequestPayload): types.RebootRequest => ({
    type: REBOOT,
    payload,
});

export const RebootSuccess = (payload: types.RebootSuccessPayload): types.RebootSuccess => ({
    type: REBOOT_SUCCESS,
    payload,
});

export const RebootFailure = (payload: types.RebootFailurePayload): types.RebootFailure => ({
    type: REBOOT_FAILURE,
    payload,
});

// reset post api
export const Reset = (payload: types.ResetRequestPayload): types.ResetRequest => ({
    type: RESET,
    payload,
});

export const ResetSuccess = (payload: types.ResetSuccessPayload): types.ResetSuccess => ({
    type: RESET_SUCCESS,
    payload,
});

export const ResetFailure = (payload: types.ResetFailurePayload): types.ResetFailure => ({
    type: RESET_FAILURE,
    payload,
});
